import Content, {
    ContentProps,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/Product/parts/Content'
import { useConfigurableContainerActions } from '@/features/pos/contexts/ConfigurableContainer'
import { FC, memo } from 'react'

interface ContainerProps extends Pick<ContentProps, 'mode' | 'name' | 'price' | 'style'> {
    id: string
}

const Container: FC<ContainerProps> = ({ id, ...contentProps }) => {
    const { set } = useConfigurableContainerActions()

    const handlePress = () => {
        set({ id, name: contentProps.name })
    }

    return <Content {...contentProps} onPress={handlePress} />
}

export default memo(Container)
